import REDIS_CACHE from '../../../constants/rediscache';

export default {
	apiUrl: REDIS_CACHE,
};
